/**
 * UK tax-year helpers. The engine's internal `year` N ALWAYS means the UK tax
 * year running 6 April N to 5 April N+1. These helpers are pure string/number
 * arithmetic — no Date objects, no system clock — so results are fully
 * deterministic.
 */
/** Display label for internal year N, e.g. 2025 → "2025/26". */
export function taxYearLabel(year) {
    if (!Number.isInteger(year))
        throw new RangeError(`Tax year must be a whole number: ${year}`);
    return `${year}/${String((year + 1) % 100).padStart(2, '0')}`;
}
/**
 * The internal year N of the UK tax year CONTAINING an ISO date — 6 April N to
 * 5 April N+1. A date on 6 April belongs to the year that starts that day.
 * Pure string comparison, so it is stable in every timezone (a `Date` would
 * shift 2026-04-06 into the previous tax year west of Greenwich).
 */
export function taxYearContaining(date) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
    if (!match)
        throw new RangeError(`Invalid ISO date: ${date}`);
    const calendarYear = Number(match[1]);
    const monthDay = `${match[2]}-${match[3]}`;
    return monthDay >= '04-06' ? calendarYear : calendarYear - 1;
}
/**
 * Age in whole years at the START of tax year N (i.e. on 6 April N), from an
 * ISO date of birth. Someone born on 6 April is treated as having had their
 * birthday by the tax-year start.
 */
export function ageAtTaxYearStart(dateOfBirth, year) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateOfBirth);
    if (!match)
        throw new RangeError(`Invalid ISO date of birth: ${dateOfBirth}`);
    const birthYear = Number(match[1]);
    const monthDay = `${match[2]}-${match[3]}`;
    const hadBirthdayBy6April = monthDay <= '04-06';
    return year - birthYear - (hadBirthdayBy6April ? 0 : 1);
}
//# sourceMappingURL=tax-year.js.map